import React, {useEffect, useState} from "react";

import './ForwardToSupportModal.scss'
import {Modal, TextArea, TextInput} from "@carbon/react";
import {
  forwardAlarmsState,
  forwardToSupportAlarmModalMessageState,
  forwardToSupportAlarmModalOpenState,
} from "../../../state/alerts_table";
import {ADD, useToastContext} from "../../Toast";
import {useRecoilState, useRecoilValue} from "recoil";
import {grpcAlarmServiceSelector} from "../../../state/grpc";

const ForwardToSupportModal = () => {
  const { toastDispatch } = useToastContext();
  const forwardAlarms = useRecoilValue(forwardAlarmsState)
  const [forwardToSupportAlarmModalOpen, setForwardToSupportAlarmModalOpen]  = useRecoilState(forwardToSupportAlarmModalOpenState)
  const [forwardToSupportAlarmModalMessage, setForwardToSupportAlarmModalMessage]  = useRecoilState(forwardToSupportAlarmModalMessageState)
  const [recipients, setRecipients] = useState([])
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  useEffect(() => {
    setForwardToSupportAlarmModalMessage("")
    setRecipients([])
  }, [forwardToSupportAlarmModalOpen])

  return (
    <Modal
      open={forwardToSupportAlarmModalOpen}
      modalHeading="Inoltra allarme all'assistenza"
      modalLabel="Dati allarme"
      primaryButtonText="Invia"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        const req = new proto.api.ForwardRequest()
        req.setAlarmidsList(forwardAlarms)
        req.setMessage(forwardToSupportAlarmModalMessage)
        req.setRecipientsList(recipients)
        alarmsService.forward(req, null, (err, resp) => {
          if (err != null) {
            console.log(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile inoltrare gli allarmi. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione completata con successo",
                content: "Allarmi inoltrati via mail",
                kind: "success"
              }
            })
            setForwardToSupportAlarmModalOpen(false)
          }
        })
      }}
      onRequestClose={() => {
        setForwardToSupportAlarmModalOpen(false)
      }}>
      <p style={{marginBottom: 'rem'}}>
        Stai inoltrando al supporto i dettagli di uno o più allarmi, per richiedere assistenza in merito al problema
        segnalato. Puoi specificare un testo aggiuntivo che verrà inserito nel messaggio inviato.
      </p>
      <br/>
      <TextArea
        data-modal-primary-focus
        maxCount={1000}
        value={forwardToSupportAlarmModalMessage}
        onChange={ev => {
          setForwardToSupportAlarmModalMessage(ev.target.value)
        }}
        id="mail-message"
        labelText="Testo aggiuntivo (opzionale)"
        style={{marginBottom: '1rem'}}
      />
      <TextInput
        value={recipients.join(',')}
        onChange={ev => {
          setRecipients(ev.target.value.split(','))
        }}
        id="mail-recipients"
        placeholder="Separare i destinatari aggiuntivi con una virgola"
        labelText="Destinatari aggiuntivi (opzionale)"
        style={{marginBottom: '1rem'}}
      />
    </Modal>
  )
}

export default ForwardToSupportModal